import { endDateBeet } from '@metaplex-foundation/mpl-candy-guard';
import { mapSerializer, createSerializerFromBeet } from '../../../types/Serializer.mjs';
import { toDateTime } from '../../../types/DateTime.mjs';

/**
 * The endDate guard is used to specify a date to end the mint.
 * Any transaction received after the end date will fail.
 *
 * This object defines the settings that should be
 * provided when creating and/or updating a Candy
 * Machine if you wish to enable this guard.
 */

/** @internal */
const endDateGuardManifest = {
  name: 'endDate',
  settingsBytes: 8,
  settingsSerializer: mapSerializer(createSerializerFromBeet(endDateBeet), settings => ({
    date: toDateTime(settings.date)
  }), settings => settings)
};

export { endDateGuardManifest };
//# sourceMappingURL=endDate.mjs.map
